/**
 * @module websocket.event.handlers.aircraft.aircraft-list-updated
 */
import { store } from '../../../../state/store'
import { setAircraftListUpdated } from '../../../../state/websocket.slice'

export default function handleAircraftListUpdated(context) {
  const { payload: { channelId, data } = {} } = context
  if (!data || !channelId) {
    return
  }

  const isSubscribed = store
    .getState()
    ?.websocket?.subscriptions?.some((channel) => channel === channelId)

  if (isSubscribed) {
    store.dispatch(setAircraftListUpdated(data))
  }
} 